<neo-error
[errorCode]="404"
[errorDescription]="'¡VAYA! Parece que no encontramos lo que buscas...'"></neo-error>

